function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { generateUniqueId } from 'seagull/utils/generateUniqueId';
import * as makers from "../service/makers";
import { ServiceTemplateStatus } from "./model";
import { BillingTriggerType } from "../../types/api.model";
import { ServiceIntegrationsModel } from "../ServiceIntegrations";
export const generateId = () => generateUniqueId('service-template');
export function clone(input) {
  return _objectSpread(_objectSpread({}, input), {}, {
    id: generateId()
  });
}
export function makeServiceTemplate(input) {
  return {
    id: input.id != null ? input.id : generateId(),
    name: input.name,
    description: input.description,
    status: input.status || ServiceTemplateStatus.Active,
    cost: input.cost,
    billing: input.billing,
    integratedId: input.integratedId != null ? input.integratedId : null,
    origin: input.origin || null,
    integrations: input.integrations || ServiceIntegrationsModel.fromDTO(undefined)
  };
}
export const makeFixedCost = makers.makeFixedCost;
export const makeVariableCost = makers.makeVariableCost;
export const makeRangeCost = makers.makeRangeCost;
export function makeBillingOnApproval() {
  return {
    trigger: BillingTriggerType.OnApproval
  };
}
export function makeBillingOneTimeManual() {
  return {
    trigger: BillingTriggerType.OneTimeManual
  };
}
export function makeBillingOneTimeDelivery() {
  return {
    trigger: BillingTriggerType.OneTimeDelivery
  };
}
export function makeBillingOngoing(recurrencePeriod) {
  return {
    trigger: BillingTriggerType.Ongoing,
    recurrencePeriod
  };
}
export function makeBillingRepeatableManual(recurrencePeriod) {
  return {
    trigger: BillingTriggerType.RepeatableManual,
    recurrencePeriod
  };
}